module.exports = __webpack_public_path__ + "img/resource-ya.8f26f3bc.png";